import { connect } from 'react-redux';
import { actions } from '../../../../../../redux/modules/bodega';
import PilasList from './Pilas';


const ms2p = (state) => {
  return {
    ...state.bodegas,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(PilasList);
